import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Reader's Ark",
    detail:
    "Reader’s Ark -  a treasure trove of captivating blogs that cover an array of fascinating topics.",
  },
  {
    icon: <MdCancel />,
    heading: "Trecento",
    detail:
      "Trecento - literally meaning 'Three Hundred' - is a name that reflects our commitment to reaching new heights and embarking on challenging journeys. With over 2000 readers, trecento consists of engaging literary articles, insightful book reviews, author interviews and captivating poetry.",
  },
  {
    icon: <MdAnalytics />,
    heading: "BubbELS",
    detail:
      "ELS Bubble is a captivating venture by the English Literary Society that takes us on an enchanting voyage through a kaleidoscope of themes and emotions.",
  },
  {
    icon: <MdAnalytics />,
    heading: "ScribbELS",
    detail:
      "In the vibrant month of April, the talented members of the English Literary Society took centre stage on our official page, embracing the freedom to exhibit their creativity with no limits.  ",
  }
];
export default data;